import React, { useEffect, useState } from "react";
import Layout from "../../common/layout";
import { useTranslation } from "react-i18next";
import { Container } from "../../common/layout/styels";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Loader from "../../../elements/loader";
import { getData, putData } from "../../../../backend/api";
import ListTable from "../../../elements/list/list";

const CompanyDetails = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.login);
  const [attributes] = useState([
    {
      type: "text",
      placeholder: "companyName",
      name: "organization",
      validation: "",
      showItem: "",
      tab: "Invoice Data",
      default: user.data.user.company || "",
      label: "companyName",
      required: true,
      view: true,
      add: false,
      update: false,
    },
    {
      type: "text",
      placeholder: "",
      name: "",
      validation: "",
      showItem: "",
      tab: "Invoice Data",
      default: "",
      label: "",
      required: false,
      view: true,
      add: false,
      update: false,
    },
    {
      type: "text",
      placeholder: "street",
      name: "streetNumber",
      validation: "",
      default: "",
      label: "street",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "houseNumber",
      name: "houseNumber",
      validation: "",
      default: "",
      label: "houseNumber",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "city",
      name: "city",
      validation: "",
      default: "",
      label: "city",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "postalCode",
      name: "postalCode",
      validation: "",
      default: "",
      label: "postalCode",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "select",
      apiType: "API",
      selectApi: "user/countries",
      showItem: "locale",
      placeholder: "country",
      name: "country",
      search: true,
      validation: "",
      default: "",
      label: "country",
      required: false,
      filter: false,
      view: false,
      tag: true,
      add: false,
      update: false,
    },
    {
      type: "text",
      placeholder: "",
      name: "",
      validation: "",
      showItem: "",
      tab: "Invoice Data",
      default: "",
      label: "",
      required: false,
      view: true,
      add: false,
      update: false,
    },
    {
      type: "text",
      placeholder: "email",
      name: "email",
      validation: "email",
      default: "",
      label: "email",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "mobileNumber",
      name: "mobileNumber",
      validation: "mobile",
      default: "",
      label: "mobileNumber",
      required: false,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "select",
      apiType: "API",
      selectApi: "user/countries",
      showItem: "locale",
      placeholder: "country",
      name: "country",
      search: true,
      validation: "",
      default: "",
      label: "country",
      required: false,
      filter: false,
      view: false,
      tag: false,
      add: true,
      update: true,
    },
  ]);
  const navigate = useNavigate();
  const [showLoader, setShowLoader] = useState(true);
  const [refreshVal, setRefreshVal] = useState(true);
  //to update the page title
  useEffect(() => {
    document.title = `${t("companyDetails")} - Whistleblowing24`;
  }, [t]);

  const [data, setData] = useState(null)

  const [advisorAttributes] = useState([
    {
      type: "text",
      placeholder: "companyName",
      name: "organization",
      validation: "",
      showItem: "",
      tab: "Invoice Data",
      default: user.data.user.company || "",
      label: "companyName",
      required: true,
      view: true,
      add: false,
      update: false,
    },
    {
      type: "text",
      placeholder: "",
      name: "",
      validation: "",
      showItem: "",
      tab: "Invoice Data",
      default: "",
      label: "",
      required: false,
      view: true,
      add: false,
      update: false,
    },
    {
      type: "text",
      placeholder: "street",
      name: "streetNumber",
      validation: "",
      default: "",
      label: "street",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "houseNumber",
      name: "houseNumber",
      validation: "",
      default: "",
      label: "houseNumber",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "postalCode",
      name: "postalCode",
      validation: "",
      default: "",
      label: "postalCode",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "city",
      name: "city",
      validation: "",
      default: "",
      label: "city",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "select",
      apiType: "API",
      selectApi: "user/countries",
      showItem: "locale",
      placeholder: "country",
      name: "country",
      search: true,
      validation: "",
      default: "",
      label: "country",
      required: false,
      filter: false,
      view: false,
      tag: true,
      add: false,
      update: false,
    },
    {
      type: "text",
      placeholder: "",
      name: "",
      validation: "",
      showItem: "",
      tab: "Invoice Data",
      default: "",
      label: "",
      required: false,
      view: true,
      add: false,
      update: false,
    },
    {
      type: "text",
      placeholder: "email",
      name: "email",
      validation: "email",
      default: "",
      label: "email",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "mobileNumber",
      name: "mobileNumber",
      validation: "mobile",
      default: "",
      label: "mobileNumber",
      required: false,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "select",
      apiType: "API",
      selectApi: "user/countries",
      showItem: "locale",
      placeholder: "country",
      name: "country",
      search: true,
      validation: "",
      default: "",
      label: "country",
      required: false,
      filter: false,
      view: false,
      tag: false,
      add: true,
      update: true,
    },
    
    // {
    //   type: "textarea",
    //   placeholder: "address",
    //   name: "address",
    //   validation: "",
    //   default: "",
    //   label: "address",
    //   required: true,
    //   view: true,
    //   add: true,
    //   update: true,
    // },
  ]);

  useEffect(() => {
    const fetchdata = async ()=>{
      setLoaderBox(true);
      try {
        await getData({}, (props.user.user?.authorisation === "advisor" && props.user.user?.partner) ? `partner?id=${props.user.user.partner}` : `company/admin?id=${props.user.user.company}`, dispatch, navigate)
          .then((response) => {
            setData(response?.data ?? null);
            setLoaderBox(false);
            setRefreshVal(false);
          })
          .catch((error) => {
            setLoaderBox(false);
            setRefreshVal(false);
          });
      } catch (error) {
        setLoaderBox(false);
        setRefreshVal(false);
      }
    }
    if(refreshVal)
      fetchdata()
  }, [refreshVal])

  const setLoaderBox = (status) => {
    setShowLoader(status);
  };
  
  // const [actions] = useState([{ element: "button", icon: "timings", type: "subList", id: "shift-timing", itemTitle: "title", title: "timings", attributes: timingAttributes, params: { api: `timing`, itemTitle: "title", shortName: "Timing", addPrivilege: true, delPrivilege: true, updatePrivilege: true, customClass: "medium" } }]);
  // Use the useTranslation hook from react-i18next to handle translations
  // const parkingDuration = totalDuration > 120 ? (days > 0 ? days + `d, ` : ``) + (hours > 0 ? hours + `h, ` : ``) + (minutes + t("m")) : totalDuration.toFixed(0) + ` ` + t("minutes");
  return (
    <Container className="noshadow">
      {/* {!!data && <DisplayInformations customClass="invoiceData" isEditingHandler={isEditingHandler} setLoaderBox={setLoaderBox} udpateView={udpateView} attributes={attributes} data={data} setMessage={setMessage} tabName="invoiceData"  />}
      {isEditing && <CrudForm delPrivilege={true} deleteHandler={null} setMessage={setMessage} formMode={"single"} formView={"normal"} api="invoiceData" formType={"put"} updateId={updateId} header={t("update", { label: t("invoiceData") })} formInput={attributes} formValues={updateValues} submitHandler={updateHandler} isOpenHandler={isEditingHandler} isOpen={isEditing}></CrudForm>}
      */}
      <ListTable {...props} actions={[]} formMode="double" api={(props.user.user?.authorisation === "advisor" && props.user.user?.partner) ? `partner` : `company/admin`} itemTitle={`title`} shortName={`companyDetails`} addPrivilege={false} delPrivilege={false} updatePrivilege={true} attributes={(props.user.user?.authorisation === "advisor" && props.user.user?.partner) ? advisorAttributes : attributes} display={true} dataVal={data} setRefreshVal={setRefreshVal} ></ListTable>
      {showLoader && <Loader></Loader>} 
    </Container>
  );
};
// exporting the page with parent container layout..
export default Layout(CompanyDetails);
